import { ImageField } from '../../../../store/types/template';

export const STAMP_WORDS = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
] as const;

export type StampWord = (typeof STAMP_WORDS)[number];

export const STAMP_NUMBER_WORDS = [
  'Zero',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
  'Ten',
  'Eleven',
  'Twelve',
] as const;

export const STAMP_BANNER_FIELDS: { field: ImageField; label: string }[] = [
  { field: 'stampZeroImage', label: 'Unstamped' },
  { field: 'stampOneImage', label: 'Stamp 1' },
  { field: 'stampTwoImage', label: 'Stamp 2' },
  { field: 'stampThreeImage', label: 'Stamp 3' },
  { field: 'stampFourImage', label: 'Stamp 4' },
  { field: 'stampFiveImage', label: 'Stamp 5' },
  { field: 'stampSixImage', label: 'Stamp 6' },
  { field: 'stampSevenImage', label: 'Stamp 7' },
  { field: 'stampEightImage', label: 'Stamp 8' },
  { field: 'stampNineImage', label: 'Stamp 9' },
  { field: 'stampTenImage', label: 'Stamp 10' },
  { field: 'stampElevenImage', label: 'Stamp 11' },
  { field: 'stampTwelveImage', label: 'Stamp 12' },
];

function capitalize(word: StampWord): Capitalize<StampWord> {
  return `${word.charAt(0).toUpperCase()}${word.slice(1)}` as Capitalize<StampWord>;
}

export function getStampImageKey(word: StampWord): string {
  return `stamp${capitalize(word)}Image`;
}

export function getStampShortValueKey(word: StampWord): string {
  return `stamp${capitalize(word)}ShortValue`;
}

export function getStampLongValueKey(word: StampWord): string {
  return `stamp${capitalize(word)}LongValue`;
}

export const STAMP_INDEX: Record<string, number> = {
  stampZeroImage: 0,
  stampOneImage: 1,
  stampTwoImage: 2,
  stampThreeImage: 3,
  stampFourImage: 4,
  stampFiveImage: 5,
  stampSixImage: 6,
  stampSevenImage: 7,
  stampEightImage: 8,
  stampNineImage: 9,
  stampTenImage: 10,
  stampElevenImage: 11,
  stampTwelveImage: 12,
};

export const STAMP_IMAGE_FIELDS = STAMP_WORDS.map(getStampImageKey);

export const STAMP_SHORT_VALUE_KEYS = STAMP_WORDS.map(getStampShortValueKey);

export const STAMP_LONG_VALUE_KEYS = STAMP_WORDS.map(getStampLongValueKey);

export const STAMP_BANNER_LABELS: Record<string, string> = {
  stampZeroImage: 'Unstamped banner',
  stampOneImage: 'Stamp one banner',
  stampTwoImage: 'Stamp two banner',
  stampThreeImage: 'Stamp three banner',
  stampFourImage: 'Stamp four banner',
  stampFiveImage: 'Stamp five banner',
  stampSixImage: 'Stamp six banner',
  stampSevenImage: 'Stamp seven banner',
  stampEightImage: 'Stamp eight banner',
  stampNineImage: 'Stamp nine banner',
  stampTenImage: 'Stamp ten banner',
  stampElevenImage: 'Stamp eleven banner',
  stampTwelveImage: 'Stamp twelve banner',
};

export const STAMP_VALUE_LABELS: Record<string, string> = {
  stampZeroShortValue: 'Unstamped',
  stampOneShortValue: 'Stamp 1',
  stampTwoShortValue: 'Stamp 2',
  stampThreeShortValue: 'Stamp 3',
  stampFourShortValue: 'Stamp 4',
  stampFiveShortValue: 'Stamp 5',
  stampSixShortValue: 'Stamp 6',
  stampSevenShortValue: 'Stamp 7',
  stampEightShortValue: 'Stamp 8',
  stampNineShortValue: 'Stamp 9',
  stampTenShortValue: 'Stamp 10',
  stampElevenShortValue: 'Stamp 11',
  stampTwelveShortValue: 'Stamp 12',
  stampZeroLongValue: 'Unstamped',
  stampOneLongValue: 'Stamp 1',
  stampTwoLongValue: 'Stamp 2',
  stampThreeLongValue: 'Stamp 3',
  stampFourLongValue: 'Stamp 4',
  stampFiveLongValue: 'Stamp 5',
  stampSixLongValue: 'Stamp 6',
  stampSevenLongValue: 'Stamp 7',
  stampEightLongValue: 'Stamp 8',
  stampNineLongValue: 'Stamp 9',
  stampTenLongValue: 'Stamp 10',
  stampElevenLongValue: 'Stamp 11',
  stampTwelveLongValue: 'Stamp 12',
};
